import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";
import LazyEagerImage from "../../atoms/lazy-eager";
import "./light-box-image.m.css";

const LightBoxImage = ({ cdnImage, story, element, closePopup, isHeroImage }) => {
  const imageS3Key = isHeroImage ? story["hero-image-s3-key"] : element["image-s3-key"];
  const elementObj = isHeroImage ? "" : element;
  const storyObj = isHeroImage ? story : "";
  const ref = useRef(null);
  const ref2 = useRef(null);

  const handleClickOutside = (event) => {
      if (ref.current && !ref2.current && !ref.current.contains(event.target)) {
         closePopup();
      } else if (ref.current && !ref.current.contains(event.target) && ref2.current && !ref2.current.contains(event.target)) {
          closePopup();
      }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <div styleName="wrapper">
      <div styleName="lightbox">
        <div styleName="lightbox-image-div">
          <div styleName="lightbox-image" className="lightbox-image">
          <figure>
            <LazyEagerImage
              styleName="light-box-single-image"
              togglePopImage={true}
              src={`https://${cdnImage}/${imageS3Key}`}
              togglePopImageFn={closePopup}
            />
          </figure>
            {isHeroImage
              ? (storyObj["hero-image-caption"] || storyObj["hero-image-attribution"]) && (
                  <div styleName="image-title-wrapper" className="voice-no-read" ref={ref2}>
                    {storyObj["hero-image-caption"] && (
                      <figcaption styleName="img-figcap" className="story-element-image-title">
                        {storyObj["hero-image-caption"]}
                      </figcaption>
                    )}
                    {storyObj["hero-image-attribution"] && (
                      <figcaption styleName="img-figcap" className="story-element-image-title">
                        Kuva: {storyObj["hero-image-attribution"]}
                      </figcaption>
                    )}
                  </div>
                )
              : (elementObj.title || elementObj["image-attribution"]) && (
                  <div styleName="image-title-wrapper" className="voice-no-read" ref={ref2}>
                    {elementObj.title && (
                      <figcaption styleName="img-figcap" className="story-element-image-title">
                        {elementObj.title}
                      </figcaption>
                    )}
                    {elementObj["image-attribution"] && (
                      <figcaption styleName="img-figcap" className="story-element-image-title">
                        Kuva: {elementObj["image-attribution"]}
                      </figcaption>
                    )}
                  </div>
                )}
          </div>
          <button onClick={closePopup} styleName="icon-close">
            <i className="ri-close-line" alt="close"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

LightBoxImage.propTypes = {
  element: PropTypes.object,
  story: PropTypes.object,
  isHeroImage: PropTypes.bool,
  index: PropTypes.number,
  closePopup: PropTypes.func,
  cdnImage: PropTypes.string
};
function mapStateToProps(state) {
  return {
    cdnImage: get(state, ["qt", "config", "cdn-image"])
  };
}
export default connect(mapStateToProps, () => ({}))(LightBoxImage);
